import api from './api'
import { getAuthorizationHeader } from '../utils'

export default {

    async getPermissoes(idUsuario, idRegional, idFilial, idEmpresa) {
        const requestOptions = {
            headers: getAuthorizationHeader()
        };
        return await api.get(`/api/Usuario/${idUsuario}/permissoes/${idRegional}/${idFilial}/true?tenantId=${idEmpresa}`, requestOptions);
    },

    async login(command){
        return await api.post(`/api/v2/Usuario/Login`, command);
    },

    async getFiliais(idUsuario) {
        const requestOptions = {
            headers: getAuthorizationHeader()
        };
        return await api.get(`/api/Usuario/${idUsuario}/filiais`, requestOptions);
    },

    async getTenants(idUsuario) {
        const requestOptions = {
            headers: getAuthorizationHeader()
        };
        return await api.get(`/api/Usuario/${idUsuario}/tenants`, requestOptions);
    }
};